import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { ItemIcon, Tooltip } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledTooltipContent = styled(Stack)`
    gap: 12px;
    width: 185px;
    max-height: 200px;
    overflow: auto;

    background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledTooltip = styled(Tooltip)`
    && {
        ${setElevation("Z3")}

        background-color: ${colorsPalettes.carbon[0]};
        border-radius: 20px;
        padding: 16px 24px;
    }

    user-select: none;
    max-width: 185px;
`;

export const TooltipTrigger = styled.span`
    display: inline-block;
`;

export const BadgeWrapper = styled.div`
    position: absolute;
    top: 24px;
    left: 24px;
    width: 8px;
    height: 8px;
`;

export const StyledItemIcon = styled(ItemIcon)`
    flex-shrink: 0;
`;
